<template>
  <div>
    <div v-if="isPageLoaded">
      <div class="product-top-bar d-flex align-items-center">
        <div class="container-fluid">
          <h2 class="text-white title m-0 text-uppercase" v-html="page.title.rendered"></h2>
        </div>
      </div>
      <!-- /.product-top-bar -->
      <div class="container-fluid">
        <div class="product-content-container" v-html="page.content.rendered"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'PageCategory',
  data () {
    return {
      api_path: process.env.VUE_APP_API_PATH,
      title: process.env.VUE_APP_TITLE,
      page: [],
      isPageLoaded: false
    }
  },
  mounted () {
    this.getPage()
  },
  methods: {
    getPage () {
      const slug = this.$route.params.slug
      const lang = this.$route.params.lang
      const $vm = this
      $vm.isPageLoaded = false
      axios.get(`${this.api_path}wp-json/wp/v2/pages`, {
        params: {
          slug,
          lang
        }
      })
        .then(res => {
          if (res.data) {
            $vm.page = res.data[0]
            $vm.isPageLoaded = true
            document.title = `${$vm.page.title.rendered} - ${$vm.title}`
          }
        })
    }
  },
  watch: {
    '$route' () {
      this.getPage()
    }
  }
}
</script>
